<template>
    <div class="nav_wrap_add">
        <div class="nav_wrap">
            <div class="nav">
            <span :class="{active:$route.path.slice(0,8) === item.path.slice(0,8)}"
                  v-for="(item,index) in about_nav" :key="index" @click="nav_link(item.path)">{{item.name}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'aboutNav',
    data () {
        return {
            about_nav:[
                {name: '公司简介',path: '/about',value:0},
                {name: '发展历程',path: '/about_progress',value:1},
                {name: '团队照片',path: '/about_team',value:2},
                {name: '运输案例',path: '/about_case',value:3},
                {name: '视频展示',path: '/about_view',value:4},
                {name: '人才招募',path: '/about_job',value:5},
            ],
        }
    },
    methods:{
        nav_link(path){
            this.$router.push({
                path:path
            }, () => {});
        }

    },
}
</script>


<style scoped>
.nav_wrap_add{width:100%;height:70px;display:block;float:left;}
.nav_wrap{width:100%;height:70px;float:left;background:url(../../static/images/sub_navbg.jpg) center no-repeat;background-size:1920px 70px;
    position:fixed;left:0;top:90px;z-index:99;}
.nav{width:1200px;height:70px;display:flex;margin:0 auto;justify-content: center;}
.nav span{width:auto;height:70px;border-bottom:3px solid;border-color:transparent;padding:0 30px;
    font-size:15px;color:#fff;line-height:68px;display:inline-block;cursor:pointer;margin:0 10px;}
.nav span:hover{color:#fff;}
.nav span.active{color:#fff;border-color:#fff;}
@media (min-width:992px) and (max-width:1200px){
    .nav_wrap_add{height:60px;}
    .nav_wrap{height:60px;background:url(../../static/images/sub_navbg.jpg) center no-repeat;background-size:1920px 60px;top:80px;}
    .nav{width:1000px;height:60px;}
    .nav span{height:60px;border-bottom:2px solid;border-color:transparent;padding:0 25px;font-size:15px;line-height:58px;margin:0 10px;}
}
@media (min-width:768px) and (max-width:991px){
    .nav_wrap_add{height:50px;}
    .nav_wrap{height:50px;background:url(../../static/images/sub_navbg.jpg) center no-repeat;background-size:1920px 50px;top:70px;}
    .nav{width:750px;height:50px;}
    .nav span{height:50px;border-bottom:2px solid;border-color:transparent;padding:0 20px;font-size:14px;line-height:48px;margin:0 5px;}
}
@media (max-width:767px){
    .nav_wrap_add{display:none;}
    .nav_wrap{display:none;}
}
</style>



// WEBPACK FOOTER //
// src/components/about_nav.vue